mutation UpdateEventMemberRole(
  $eventId: ID!
  $userId: String!
  $role: StreamToolsEventMemberRole!
) {
  member: StreamToolsUpdateEventMemberRole(eventId: $eventId, userId: $userId, role: $role) {
    eventId
    userId
    email
    displayName
    role
    addedBy
    addedAt
  }
}
